import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import api from '../../api';
import { deleteDeviceUrl } from "../../config";
import { IInitialSliceState } from "../../common/types/commonTypes";
import { getCookie } from "../../common/utils";

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  msg: null
};

interface IDeleteDeviceResponse {
  message: string
}

export const deleteDeviceModal = createAsyncThunk("deleteDevice", async (deviceId: string, { rejectWithValue }) => {
  try {
    const organizationId: string = getCookie('organizationId');
    const response = await api.delete<IDeleteDeviceResponse>(deleteDeviceUrl + `?deviceId=${deviceId}`, { headers: { organizationId: organizationId } });
    const deleteDeviceResponse: IDeleteDeviceResponse = response.data;
    return deleteDeviceResponse;
  } catch (error) {
    throw rejectWithValue(error);
  }
}
);

const deleteDeviceModalSlice = createSlice({
  name: "deleteDevice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteDeviceModal.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(deleteDeviceModal.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.status = Status.SUCCESS;
      })
      .addCase(deleteDeviceModal.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
        state.msg = errorPayload.response?.data?.error?.message || errorPayload.response?.data?.message || 'Unknown error occurred';
        state.status = Status.SUCCESS;
      });
  },
});

export default deleteDeviceModalSlice.reducer;